export default __webpack_public_path__ + "static/media/book3.a9162dd4.jpg";